import { PrimaryButton, InputDropdown, Input, Alert } from '@artprov/design-system'
import { useDatosPersonales } from './datos-personales.hook'
import { Show } from '../../../common/components/Show'
import { Status } from './lib/utils'
export function DatosPersonalesSection() {
  const { formData, errors, tiposDocumento, onFieldChange, onSubmit, disabled, status } = useDatosPersonales()

  const getTipoDocToDom = () => {
    let opciones = []
    // const tipoDocsOptions = getOpcionesTipoDoc()
    for (const item of tiposDocumento) {
      opciones.push(
        <InputDropdown.Option id={item.id} value={item.valueToShow}>
          {item.valueToShow}
        </InputDropdown.Option>
      )
    }

    return opciones
  }

  const handleOnChangeTipoDoc = (event) => {
    if (event.value) {
      let e = tiposDocumento.filter((el) => {
        return el.valueToShow == event.value
      })[0]
      onFieldChange('tipoDocumento', e?.id)
    }
  }

  const formatNroDoc = (value) => {
    if (!value) return ''
    const clean = String(value).replace(/\./g, '')
    return clean.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  return (
    <section className="flex flex-col gap-4 bg-tertiary-98 p-4 rounded w-full">
      <p className="text-lg font-semibold">Datos personales</p>
      <div className="flex flex-col gap-6 bg-tertiary-100 p-6 border border-tertiary-80 rounded-lg">
        <div>
          <Show when={status === Status.CREATE_USER}>
            <Alert
              variant="error"
              containerStyle="max-w-none "
              description={'Error al crear el usuario. Por favor intente nuevamente.'}
              interactive={false}
              autoDismiss={false}
              iconStyle="text-error-10"
              icon="cancel"
            />
          </Show>
          <div className="grid grid-cols-12 gap-4 mb-3 primeraRow">
            <div className="col-span-6">
              <InputDropdown
                defaultSelection={false}
                isRequired
                key={`tipDoc-123`}
                label="Tipo de documento"
                status={errors.tipoDocumento?.length > 0 ? 'error' : 'default'}
                // hints={errors.tipoDocumento || []}
                placeholder="Seleccione"
                onChange={(event) => {
                  const value = event?.value || event?.target?.value || event || ''
                  handleOnChangeTipoDoc({ value })
                  // onFieldChange('tipoDocumento', value)
                }}
              >
                {getTipoDocToDom()}
              </InputDropdown>
            </div>
            <div className="col-span-6">
              <Input
                id="documento"
                className="min-w-[200px]"
                isRequired
                type="text"
                label="N° de documento"
                placeholder="20.123.456"
                maxCharacters={11} // includes dots
                disabled={false}
                value={formatNroDoc(formData?.documento)}
                status={errors.documento?.length > 0 ? 'error' : 'default'}
                hints={errors.documento || []}
                onChange={(e) => {
                  const raw = e.replace(/\./g, '')
                  onFieldChange('documento', raw)
                }}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 mb-3 primeraRow">
          <div className="col-span-6">
            <Input
              type="text"
              label="Apellido y Nombre"
              isRequired
              status={errors.nombreCompleto?.length ? 'error' : 'default'}
              hints={errors.nombreCompleto || []}
              placeholder="Ej. Rodriguez Juan"
              disabled={false}
              value={formData?.nombreCompleto}
              onChange={(e) => {
                onFieldChange('nombreCompleto', e)
              }}
            />
          </div>
          <div className="col-span-6">
            <Input
              id="celular"
              type="text"
              label="Número de celular"
              status={errors.celular?.length > 0 ? 'error' : 'default'}
              hints={errors.celular || []}
              placeholder="11 12345678"
              disabled={false}
              value={formData?.celular}
              onChange={(e) => {
                onFieldChange('celular', e)
              }}
            />
          </div>
        </div>

        <PrimaryButton className="w-full mt-4" disabled={disabled} onClick={onSubmit}>
          Guardar y continuar
        </PrimaryButton>
      </div>
    </section>
  )
}
